module.exports = __webpack_public_path__ + "media/images/unsplash_attribution-9e10be308eb9c67ecbdf8b7ce3a8ac2d.png";